type Region = {
  code?: string;
  name?: string;
  id?: number;
};

export type RegionWithRequiredFields = Required<Region>;
